<div class="row justify-content-md-center no-gutters greyBgBody text-center marL10" >
    <app-loader-icon *ngIf="showLoader"></app-loader-icon>
    <div class="col-12">
        <div class="row no-gutters">
            <div class="col-12 manageMailBoxSection whiteBg">
              <form [formGroup]="addClientForm" (ngSubmit)="onSubmitVerifyCompany($event)">
                <h5 class="sectionTitleBig text-left">Create Organization</h5>
                <div class="row">
                  <div class="col-3 display_inlineBlock align-section-left">
                    <label for="CompanyName">Company/Organization<span class="mandatoryMark">*</span></label>

                    <div class="form-group">
                      <input class="form-control" type="text" formControlName="CompanyName" id="CompanyName" (keydown.enter)="onSubmitVerifyCompany($event)"
                             [ngClass]="{ 'is-invalid': addClientForm.get('CompanyName').invalid && validForm } " (focusout)="onFocusOutCompany($event)" [(ngModel)]="companyName" required />
                    </div>
                  </div>
                  <div class="col-3 display_inlineBlock align-section-left">
                    <div class="row">
                      <div class="col-12">
                        <label for="clientProgram">Client Program<span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select class="form-control custom-select" id="clientProgram" formControlName="clientProgram"
                                  (ngModelChange)="onClientChange($event)" (keydown.enter)="onSubmitVerifyCompany($event)"
                                  [ngClass]="{ 'is-invalid': addClientForm.get('clientProgram').invalid && validForm }" required>
                            <option [ngValue]="null" hidden disabled selected>Select</option>
                            <option *ngFor="let item of dropdownData.ClientPrograms"
                                    [attr.selected]="item.ClientProgramID==session.ClientProgramID?true:null"
                                    [attr.value]='item.ClientProgramID'>
                              {{item.ClientProgramName}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>

                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-3 display_inlineBlock align-section-left">
                    <label for="DunsId">DUNS<span class="mandatoryMark">*</span></label>

                    <div class="form-group">
                      <input class="form-control" type="text" id="DunsId" formControlName="DunsId" (keydown.enter)="onSubmitVerifyCompany($event)"
                             [ngClass]="{ 'is-invalid': (addClientForm.get('DunsId').invalid && validForm) || !validDunsId || isCompanyExists}"
                         (focusout)="onFocusOutDunsId($event)" (keypress)="acceptAlphanumericInput($event)" required />
                      <span class="errorMsgLabel" *ngIf="!validDunsId">{{DunsErrorMsg}}</span>
                    </div>
                  </div>
                </div>

                <!-- new fields -->
                <div class="row">
                  <div class="col-3 display_inlineBlock align-section-left">
                    <div class="row">
                      <div class="col-12">
                        <label for="accountHierarchy">Account Hierarchy<span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select class="form-control custom-select" id="accountHierarchy" formControlName="accountHierarchy"
                                   (keydown.enter)="onSubmitVerifyCompany($event)" [(ngModel)]="accountHierarchy" (ngModelChange)="onaccountHierarchyChange($event)"
                                  [ngClass]="{ 'is-invalid': addClientForm.get('accountHierarchy').invalid && validForm }" required>
                            <option [ngValue]="null" hidden disabled selected>Select</option>
                            <option *ngFor="let item of accountHierarchyList"
                                    [attr.value]='item'>
                              {{item}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>

                        </div>

                      </div>
                    </div>

                  </div>
                  <div class="col-3 display_inlineBlock align-section-left">
                    <label for="ParentAccountName">Parent Account Name<span class="mandatoryMark" *ngIf="accountHierarchy != 'Parent'">*</span></label>

                    <div class="form-group">
                      <input class="form-control" type="text" formControlName="ParentAccountName" id="ParentAccountName" (keydown.enter)="onSubmitVerifyCompany($event)"
                             [ngClass]="{ 'is-invalid': addClientForm.get('ParentAccountName').invalid && validForm ,
                                         'disabled-input': accountHierarchy == 'Parent'} " (focusout)="onFocusOutParentCompany($event)"   required />
                    </div>
                  </div>
                  <div class="col-3 display_inlineBlock align-section-left">
                    <label for="ParentDunsId">Parent Account DUNS<span class="mandatoryMark" *ngIf="accountHierarchy != 'Parent'">*</span></label>

                    <div class="form-group">
                      <input class="form-control" type="text" id="ParentDunsId" formControlName="ParentDunsId" (keydown.enter)="onSubmitVerifyCompany($event)"
                              [ngClass]="{
                                         'is-invalid': (addClientForm.get('ParentDunsId').invalid && validForm) || !validParentDunsId ,
                                         'disabled-input': accountHierarchy == 'Parent'
                                       }"
                             (keypress)="acceptAlphanumericInput($event)"  (focusout)="onFocusOutParentDunsId($event)"  required />
                      <span class="errorMsgLabel" *ngIf="!validParentDunsId">{{ParentDunsErrorMsg}}</span>
                    </div>
                  </div>
                </div>
                <!-- end new fields -->
                <div class="row">
                  <div class="col-3 display_inlineBlock align-section-left">
                    <div class="row">
                      <div class="col-12">
                        <label for="select-industry">Industry<span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select class="form-control custom-select" id="select-industry" (ngModelChange)="industryChange($event)"
                                  formControlName="sessionIndustry" (keydown.enter)="onSubmitVerifyCompany($event)"
                                  [ngClass]="{ 'is-invalid': addClientForm.get('sessionIndustry').invalid && validForm }" required>


                            <option [ngValue]="null" hidden disabled selected>
                              Select
                            </option>
                            <option *ngFor="let item of dropdownData.Industries"
                                    [attr.selected]="item.ID==session.industryid?true:null"
                                    [attr.value]='item.ID'
                                    [hidden]="item.IsMDR || (!showNAFields && item.ID == 34)">
                              {{item.Name}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>

                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-3 display_inlineBlock align-section-left">
                    <div class="row">
                      <div class="col-12">
                        <label for="select-sector">Sector<span class="mandatoryMark">*</span></label>
                        <div class="form-group">
                          <select class="form-control custom-select" id="select-sector" formControlName="sessionSector"
                                  (ngModelChange)="onSectorChange($event)" (keydown.enter)="onSubmitVerifyCompany($event)"
                                   [ngClass]="{ 'is-invalid': addClientForm.get('sessionSector').invalid && validForm}" required>


                            <option [ngValue]="null" hidden disabled selected>Select</option>
                            <option *ngFor="let item of dropdownData_Sectors"
                                    [attr.selected]="item.SectorID==session.sectorid?true:null"
                                    [attr.value]='item.SectorID'>
                              {{item.SectorName}}
                            </option>
                          </select>
                          <i class="fa fa-chevron-down"></i>

                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-12 separateLineTop">
                  <div class="col-12 ">
                    <div class="text-right">
                      <button type="submit"
                              class="clickBtn saveBtn">
                        Save
                      </button>
                      <button type="button" class="clickBtn" (click)="reDirectToSearch()">
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

                <div id="errorMsg" class="errorMessage">
                  <div class="mandatoryFieldsError" *ngIf="!addClientForm.valid && validForm">
                    Please fill all the mandatory fields (*)
                  </div>
                  <div class="mandatoryFieldsError" *ngIf="isCompanyExists">
                    Company/Organization already exists. Please check the details.
                  </div>
                </div>
              </form>
    </div>

    </div>
    </div>

</div>

<!-- Modal -->
<div class="updateEmail">
    <ng-template #content let-modal>
      <div class="modal-header">
      </div>
      <div class="modal-body">
        <div *ngIf="resultModalContent">
          <p>
              {{resultModalContent}}
          </p>
      </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="verifyCompanyRes == 2" type="button" class="clickBtn"
                data-bs-dismiss="modal" (click)="onSubmitAddCompany('UPDATE',addClientForm.value);modal.dismiss('Cross click')">
            Yes
        </button>
        <button *ngIf="verifyCompanyRes == 2" type="button" class="clickBtn"
                data-bs-dismiss="modal" (click)="modal.dismiss('Cross click')">
            Cancel
        </button>
    </div>
    </ng-template>
  </div>
